import React from 'react';
import {
  MarkdownLinkPreviewContext,
  type MarkdownLinkPreviewCache,
} from './markdownLinkPreviewContext';

export type MarkdownLinkPreviewProviderProps = {
  previews: MarkdownLinkPreviewCache;
  children: React.ReactNode;
};

export const MarkdownLinkPreviewProvider: React.FC<
  MarkdownLinkPreviewProviderProps
> = ({ previews, children }) => (
  <MarkdownLinkPreviewContext.Provider value={previews}>
    {children}
  </MarkdownLinkPreviewContext.Provider>
);
